import { Home, ShoppingBag, Info } from "lucide-react";
import useFeatures from "@/constants/useFeatures";

const ITEMS = [
  { id: 0, label: "Home", icon: Home, testId: "nav-home" },
  { id: 1, label: "Categoria", icon: ShoppingBag, testId: "nav-categoria", feature: "shop" },
  { id: 2, label: "Info", icon: Info, testId: "nav-info" },
];

export default function BottomNav({ tab, goTo }) {
  const features = useFeatures();
  const items = ITEMS.filter((it) => !it.feature || features[it.feature]);
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 z-50 w-full max-w-md -translate-x-1/2 border-t border-white/10 bg-zinc-950/85 backdrop-blur-xl"
    >
      <div
        className="grid px-4 pb-5 pt-3"
        style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
      >
        {items.map(({ id, label, icon: Icon, testId }) => {
          const active = tab === id;
          return (
            <button
              key={id}
              data-testid={testId}
              onClick={() => goTo(id)}
              className="group flex flex-col items-center gap-1"
            >
              <span
                className={`flex h-10 w-14 items-center justify-center rounded-full transition-colors duration-200 ${
                  active ? "bg-amber-400/15 text-amber-400" : "text-zinc-500 group-hover:text-zinc-300"
                }`}
              >
                <Icon size={20} strokeWidth={active ? 2.4 : 1.8} />
              </span>
              <span
                className={`text-[10px] font-semibold uppercase tracking-widest transition-colors duration-200 ${
                  active ? "text-amber-400" : "text-zinc-500"
                }`}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
